import React from "react";
import logoXavier from "../../../assets/logo_xavier.png";
import "./XavierWordmark.css";

export default function XavierWordmark({ compact = false }) {
  return (
    <span className={`xv-wordmark ${compact ? "is-compact" : ""}`}>
      <span className="xv-wordmark__image-frame">
        <img src={logoXavier} alt="Xavier Advocacia" />
      </span>
    </span>
  );
}
